import { NgModule } from '@angular/core';
import { QueuingSystemSharedModule } from '../../shared';
import { RouterModule } from '@angular/router';

import { QUEUES_HANDLING_ROUTE } from './queues-handling.route';
import { QueuesHandlingComponent } from './queues-handling.component';
import { QueuesHandlingNavigationMenuModule } from './queues-handling-navigation-menu/queues-handling-navigation-menu.module';
import { GenericModule } from '../generic/';

@NgModule({
    imports: [
        QueuingSystemSharedModule,
        RouterModule.forRoot([QUEUES_HANDLING_ROUTE]),
        QueuesHandlingNavigationMenuModule,
        GenericModule
    ],
    declarations: [
        QueuesHandlingComponent
    ]
})
export class QueuesHandlingModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/queues-handling/queues-handling.module.ts